module.exports={
	"Hash": "neo-tokyo",
	"Name": "Neo-Tokyo",
	"Version": "1.0.0",
	"Description": "Cinematic deep navy with Akira red and electric blue; a clean daytime navy-and-red light variant.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#eef2f9",
					"Dark": "#0a0e1a"
				},
				"Secondary": {
					"Light": "#e4ebf6",
					"Dark": "#101a30"
				},
				"Tertiary": {
					"Light": "#d9e2f0",
					"Dark": "#16243f"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#0c1322"
				},
				"Hover": {
					"Light": "#e6edf7",
					"Dark": "#1b2c4c"
				},
				"Selected": {
					"Light": "#f6d8dd",
					"Dark": "#55182a"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#0a0e1a",
					"Dark": "#dfe8f7"
				},
				"Secondary": {
					"Light": "#33405a",
					"Dark": "#bccadf"
				},
				"Muted": {
					"Light": "#5a6a85",
					"Dark": "#7689a8"
				},
				"Placeholder": {
					"Light": "#8492a8",
					"Dark": "#566884"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#ffffff"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#e60026",
					"Dark": "#ff2d55"
				},
				"PrimaryHover": {
					"Light": "#c00020",
					"Dark": "#ff556f"
				},
				"Accent": {
					"Light": "#1366d6",
					"Dark": "#27a0ff"
				}
			},
			"Border": {
				"Light": "#cfd9ea",
				"Dark": "#1d2c4a"
			},
			"Status": {
				"Success": {
					"Light": "#0a9e88",
					"Dark": "#13e0c4"
				},
				"Warning": {
					"Light": "#b86a00",
					"Dark": "#ffb200"
				},
				"Error": {
					"Light": "#e60026",
					"Dark": "#ff453a"
				},
				"Info": {
					"Light": "#1366d6",
					"Dark": "#27a0ff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#e4ebf6",
					"Dark": "#101a30"
				},
				"Thumb": {
					"Light": "#cfd9ea",
					"Dark": "#1d2c4a"
				},
				"Hover": {
					"Light": "#5a6a85",
					"Dark": "#7689a8"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#e60026",
					"Dark": "#ff2d55"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#ffffff"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#e60026",
					"Dark": "#ff2d55"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}
